import React, { useEffect, useMemo, useState } from "react";
import {
  downloadBlob,
  getSignedData,
  getSignedDocfile,
  fetchAccounts,
} from "utils/api";
import { ACCOUNT_TYPE } from "utils/consts";
import { Table, Button, notification, Spin, Tabs, Skeleton } from "antd";
import { withRouter } from "react-router-dom";

import "components/css/Training.scss";

const AdminSign = () => {
  const [role, setRole] = useState(ACCOUNT_TYPE.MENTEE);
  const [signedData, setSignedData] = useState([]);
  const [reload] = useState(true);
  const [translateLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [, setHubOptions] = useState([]);
  const [resetFilters, setResetFilters] = useState(false);

  useEffect(() => {
    async function getHubData() {
      var temp = [];
      const hub_data = await fetchAccounts(ACCOUNT_TYPE.HUB);
      hub_data.map((hub_item) => {
        temp.push({ label: hub_item.name, value: hub_item._id.$oid });
        return true;
      });
      setHubOptions(temp);
    }
    getHubData();
  }, []);

  const handleTrainingDownload = async (record) => {
    let response = await getSignedDocfile(record._id.$oid, role);
    if (!response) {
      notification.error({
        message: "ERROR",
        description: "Couldn't download file",
      });
      return;
    }
    downloadBlob(
      response,
      role === "policy" ? "Policy_doc.pdf" : "signed_document.pdf"
    );
  };

  useMemo(() => {
    const getData = async () => {
      setLoading(true);
      let newData = await getSignedData(role);
      if (newData) {
        setSignedData(newData);
      } else {
        setSignedData([]);
        notification.error({
          message: "ERROR",
          description: "Couldn't get trainings",
        });
      }
      setLoading(false);
    };
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role, reload]);

  const columns = [
    {
      title: role === "policy" ? "Name" : "User",
      dataIndex: role === "policy" ? "name" : "user_email",
      key: role === "policy" ? "name" : "user_email",
      render:
        role === "policy"
          ? (name) => <>{name}</>
          : (user_email) => <>{user_email}</>,
    },
    {
      title: "Document",
      dataIndex: "id",
      key: "document",
      render: (id, record) => {
        return (
          <Button onClick={() => handleTrainingDownload(record)}>
            {role === "policy" ? "Download Policy PDF" : "Download Signed PDF"}
          </Button>
        );
      },
    },
    {
      title: "Signed Date",
      dataIndex: "date_submitted",
      key: "date_submitted",
      render: (date_submitted) => (
        <>{new Date(date_submitted.$date).toLocaleString()}</>
      ),
    },
  ];

  const tabItems = [
    {
      label: `Mentee`,
      key: ACCOUNT_TYPE.MENTEE,
      disabled: translateLoading,
    },
    {
      label: `Mentor`,
      key: ACCOUNT_TYPE.MENTOR,
      disabled: translateLoading,
    },
    {
      label: `Partner`,
      key: ACCOUNT_TYPE.PARTNER,
      disabled: translateLoading,
    },
  ];

  return (
    <div className="trains">
      <Tabs
        defaultActiveKey={ACCOUNT_TYPE.MENTEE}
        onChange={(key) => {
          setRole(key);
          setResetFilters(!resetFilters);
        }}
        items={tabItems}
      />
      <div className="flex" style={{ marginBottom: "1rem" }}>
        {/* <div style={{ lineHeight: "30px", marginLeft: "1rem" }}>Hub</div>
        <HubsDropdown
          className="table-button hub-drop-down"
          options={hubOptions}
          onChange={(key) => searchbyHub(key)}
          onReset={resetFilters}
        />
        <Button className="" onClick={() => handleResetFilters()}>
          Clear Filters
        </Button> */}
      </div>
      <Spin spinning={translateLoading}>
        <Skeleton loading={loading} active>
          <Table columns={columns} dataSource={signedData} />
        </Skeleton>
      </Spin>
    </div>
  );
};

export default withRouter(AdminSign);
